import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { useLocation } from 'react-router-dom';

import { ButtonTypes, PageTypes, IconTypes } from 'constants/Constants';

import Button from 'components/common/Button/Button';
import IconButton from 'components/common/IconButton/IconButton';

import styles from './AppHeaderNav.module.scss';

const s = classNames.bind(styles);

const AppHeaderNav = ({ authenticated }) => {
	const nav = useRef();
	const [showScrollLeft, setShowScrollLeft] = useState(false);
	const [showScrollRight, setShowScrollRight] = useState(false);
	const location = useLocation();

	useEffect(() => {
		if (nav.current) {
			if (nav.current.clientWidth < nav.current.scrollWidth) {
				setShowScrollRight(true);
			}
		}
	}, [authenticated]);

	/**
	 * @function getColor
	 * @param path
	 * @return {string|string}
	 */
	const getColor = path => {
		if (location.pathname === '/') {
			return ButtonTypes.NAV;
		}
		const firstUrl = location.pathname.split('/');
		return path.includes(firstUrl[1]) ? ButtonTypes.NAV_ACTIVE : ButtonTypes.NAV;
	};

	/**
	 * @function handleScroll
	 * @description Show/Hide scroll indicators
	 */
	const handleScroll = () => {
		if (nav.current) {
			const maxScrollLeft = nav.current.scrollWidth - nav.current.clientWidth;

			if (nav.current.scrollLeft > 40) {
				setShowScrollLeft(true);
			} else {
				setShowScrollLeft(false);
			}

			if (maxScrollLeft === nav.current.scrollLeft) {
				setShowScrollRight(false);
			} else if (nav.current.clientWidth < nav.current.scrollWidth) {
				setShowScrollRight(true);
			} else {
				setShowScrollRight(false);
			}
		}
	};

	if (!authenticated) {
		return null;
	}

	return (
		<>
			<IconButton
				icon={IconTypes.CHEVRON_LEFT}
				className={s('scrollLeft', { scrollLeft_hidden: !showScrollLeft })}
				size={ButtonTypes.MEDIUM}
				disabled
			/>
			<nav className={s('nav')} ref={nav} onScroll={() => handleScroll()}>
				<Button
					size={ButtonTypes.MEDIUM}
					color={getColor('/categories')}
					text={'Categories'}
					to={PageTypes.CATEGORIES.path}
					className={s('navBtn')}
					icon={IconTypes.MONITORING_CATEGORIES}
					withIconLeft
				/>
				<Button
					size={ButtonTypes.MEDIUM}
					color={getColor('/profiles')}
					text="Profiles"
					to={PageTypes.PROFILES.path}
					className={s('navBtn')}
					icon={IconTypes.MONITORING_PROFILES}
					withIconLeft
				/>
				<Button
					size={ButtonTypes.MEDIUM}
					color={getColor('/monitored-sources')}
					text="Monitored sources"
					to={PageTypes.MONITORED_SOURCES.path}
					className={s('navBtn')}
					icon={IconTypes.MONITORING_SOURCES}
					withIconLeft
				/>
				<Button
					size={ButtonTypes.MEDIUM}
					color={getColor('/queries')}
					text="Queries"
					to={PageTypes.QUERIES.path}
					className={s('navBtn')}
					icon={IconTypes.MONITORING_QUERIES}
					withIconLeft
				/>
				<Button
					size={ButtonTypes.MEDIUM}
					color={getColor('/sites')}
					text={'Sites'}
					to={PageTypes.SITES.path}
					className={s('navBtn')}
					icon={IconTypes.MONITORING_SITES}
					withIconLeft
				/>
				<Button
					size={ButtonTypes.MEDIUM}
					color={getColor('/posts')}
					text={'Posts'}
					to={'/posts'}
					className={s('navBtn')}
					icon={IconTypes.MONITORING_POSTS}
					withIconLeft
				/>
				<Button
					size={ButtonTypes.MEDIUM}
					color={getColor('/settings')}
					text={'Settings'}
					to={PageTypes.SETTINGS_PAGE.path}
					className={s('navBtn')}
					icon={IconTypes.SETTINGS_OUTLINED}
					withIconLeft
				/>
				<Button
					size={ButtonTypes.MEDIUM}
					color={getColor('/logs')}
					text="Logs"
					to={PageTypes.LOGS_PAGE.path}
					className={s('navBtn')}
					icon={IconTypes.MONITORING_LOGS}
					withIconLeft
				/>
			</nav>
			<IconButton
				icon={IconTypes.CHEVRON_RIGHT}
				className={s('scrollRight', { scrollRight_hidden: !showScrollRight })}
				size={ButtonTypes.MEDIUM}
				disabled
			/>
		</>
	);
};

AppHeaderNav.propTypes = {
	authenticated: PropTypes.bool
};

export default AppHeaderNav;
